'use client';

import Link from 'next/link';
import { GET } from '@/api/get-request';
import { Box, Stack } from '@mui/material';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useParams } from 'next/navigation';
const Container = dynamic(() => import('@/components/common/container'), { ssr: false });
const ActionCard = dynamic(() => import('@/components/pages/dana/action-card'), { ssr: false });
const Head = dynamic(() => import('@/components/pages/dana/list-head'), { ssr: false });
const ChatHistory = dynamic(() => import('@/components/pages/dana/chats-list'), { ssr: false });

interface DanaChat {
    id: number;
    title?: string;
    messages: Array<{ message: string }>;
}

export default function ChatHistoryPage() {
    const [chats, setChats] = useState<DanaChat[]>([]);

    const params = useParams() as { chatId?: string[] };
    const first = Array.isArray(params.chatId) ? params.chatId[0] : undefined;
    const initialId = first ? Number(first) : null;

    useEffect(() => {
        GET({ url: 'v1/dana/chats' })
            .then(response => {
                const data = Array.isArray(response.data)
                    ? response.data
                    : Array.isArray(response.data.data)
                        ? response.data.data
                        : [];
                setChats(data);
            })
            .catch(console.error);
    }, [initialId]);

    return (
        <Box
            height={'75vh'}
        >
            <Container
                padding="24px"
                background="var(--color-grayBackground)"
                width="100%"
                className='max-h-full h-full'
            >
                <Stack
                    spacing={5}
                    useFlexGap
                    maxHeight={'100%'}
                >
                    <ActionCard />
                    <Head />

                    {chats.length === 0 && <p>No chats yet.</p>}

                    <Box
                        maxHeight={'55vh'}
                        overflow={'auto'}
                    >
                        {chats.map(chat => (
                            <Box

                                key={chat.id}
                            >
                                <Link
                                    key={chat.id}
                                    href={`/dana/chat/${chat.id}`}
                                    className="no-underline"
                                >
                                    {/* now clicking the title will navigate to /dana/chat/[chat.id] */}
                                    <ChatHistory title={chat.title ?? 'Untitled Chat'} />
                                </Link>
                            </Box>
                        ))}
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
}
